import { T, scoreColor } from "../tokens";
import { useCountUp, useMotion } from "../hooks/useMotion";

interface Props {
  score:      number;
  size?:      number;
  delay?:     number; // reveal delay ms (for staggered entry)
  showLabel?: boolean;
}

export function ScoreRing({ score, size = 60, delay = 0, showLabel }: Props) {
  const m       = useMotion();
  const r       = size / 2 - 5;
  const circ    = 2 * Math.PI * r;
  const col     = scoreColor(score);
  const animated = useCountUp(score, { delay, duration: 1100 });
  const ringPct  = animated / 100;
  const lbl      = showLabel ?? size > 52;

  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)", display: "block" }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={T.s3} strokeWidth="3"/>
        <circle
          cx={size/2} cy={size/2} r={r} fill="none" stroke={col} strokeWidth="3"
          strokeDasharray={`${ringPct * circ} ${circ}`}
          strokeLinecap="round"
          style={{ transition: m === 0 ? "none" : "stroke-dasharray 0.05s linear" }}
        />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontFamily: T.mono, fontSize: size > 52 ? "14px" : "11px", fontWeight: 600, color: col, lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
          {animated}
        </span>
        {lbl && (
          <span style={{ fontFamily: T.body, fontSize: "8px", color: T.t3, letterSpacing: "0.06em", textTransform: "uppercase", marginTop: "2px" }}>
            match
          </span>
        )}
      </div>
    </div>
  );
}
